/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSettingsUpdateRequest
 */
export interface PaymentSettingsUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PaymentSettingsUpdateRequest
     */
    isInvoiceBeforePayment: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentSettingsUpdateRequest
     */
    platformSubsidiaryId: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentSettingsUpdateRequest
     */
    paymentTermInDays: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentSettingsUpdateRequest
     */
    contractReference?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentSettingsUpdateRequest
     */
    applyEndOfMonthRule?: boolean;
}

/**
 * Check if a given object implements the PaymentSettingsUpdateRequest interface.
 */
export function instanceOfPaymentSettingsUpdateRequest(value: object): value is PaymentSettingsUpdateRequest {
    if (!('isInvoiceBeforePayment' in value) || value['isInvoiceBeforePayment'] === undefined) return false;
    if (!('platformSubsidiaryId' in value) || value['platformSubsidiaryId'] === undefined) return false;
    if (!('paymentTermInDays' in value) || value['paymentTermInDays'] === undefined) return false;
    return true;
}

export function PaymentSettingsUpdateRequestFromJSON(json: any): PaymentSettingsUpdateRequest {
    return PaymentSettingsUpdateRequestFromJSONTyped(json, false);
}

export function PaymentSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isInvoiceBeforePayment': json['isInvoiceBeforePayment'],
        'platformSubsidiaryId': json['platformSubsidiaryId'],
        'paymentTermInDays': json['paymentTermInDays'],
        'contractReference': json['contractReference'] == null ? undefined : json['contractReference'],
        'applyEndOfMonthRule': json['applyEndOfMonthRule'] == null ? undefined : json['applyEndOfMonthRule'],
    };
}

export function PaymentSettingsUpdateRequestToJSON(value?: PaymentSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isInvoiceBeforePayment': value['isInvoiceBeforePayment'],
        'platformSubsidiaryId': value['platformSubsidiaryId'],
        'paymentTermInDays': value['paymentTermInDays'],
        'contractReference': value['contractReference'],
        'applyEndOfMonthRule': value['applyEndOfMonthRule'],
    };
}

